import {
  IGlobalState,
  START_GLOBAL_SEARCH_QUERY,
  SUCCESS_GLOBAL_SEARCH_QUERY,
  SUCCESS_SET_GLOBAL_BRAND,
  SUCCESS_SET_GLOBAL_COUNTRIES,
  SUCCESS_SET_GLOBAL_COUNTRY,
  SUCCESS_SET_GLOBAL_FAMILY,
  SUCCESS_SET_GLOBAL_LANGUAGE,
  SUCCESS_SET_GLOBAL_LINE,
  SUCCESS_SET_GLOBAL_ORDERBY,
  SUCCESS_SET_GLOBAL_ROLE,
  SUCCESS_SET_GLOBAL_TAG
} from '../types'

const isNull = (itemValue: string | null) => itemValue === null || itemValue === 'null'

const split = (countries_ids: string) => {
  if (!countries_ids) return []

  let countriesIds = countries_ids.split(',')

  let countriesIdsFormat = []
  for (let index = 0; index < countriesIds.length; index++) {
    countriesIdsFormat.push(Number(countriesIds[index]))
  }

  return countriesIdsFormat
}

const initialState: IGlobalState = {
  globalFamilyId: isNull(localStorage.getItem('globalFamilyId')) ? null : Number(localStorage.getItem('globalFamilyId')),
  globalBrandId: isNull(localStorage.getItem('globalBrandId')) ? null : Number(localStorage.getItem('globalBrandId')),
  globalLineId: isNull(localStorage.getItem('globalLineId')) ? null : Number(localStorage.getItem('globalLineId')),
  globalLanguageId: isNull(localStorage.getItem('globalLanguageId')) ? null : Number(localStorage.getItem('globalLanguageId')),
  globalCountryId: isNull(localStorage.getItem('globalCountryId')) ? null : Number(localStorage.getItem('globalCountryId')),
  globalCountriesId: split(localStorage.getItem('globalCountriesId') || ''),
  globalRoleId: isNull(localStorage.getItem('globalRoleId')) ? null : Number(localStorage.getItem('globalRoleId')),
  globalOrderById: isNull(localStorage.getItem('globalOrderById')) ? 0 : Number(localStorage.getItem('globalOrderById')),
  globalTag: isNull(localStorage.getItem('globalTag')) ? null : Number(localStorage.getItem('globalTag')),
  globalSearch: {
    courses: [],
    events: [],
    offers: [],
    novelties: [],
    resources: [],
    seminars: [],
    count: 0
  },
  loadingSearch: false
}

export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_GLOBAL_SEARCH_QUERY:
      return {
        ...state,
        loadingSearch: true
      }
    case SUCCESS_SET_GLOBAL_FAMILY:
      return {
        ...state,
        globalFamilyId: action.payload
      }
    case SUCCESS_SET_GLOBAL_BRAND:
      return {
        ...state,
        globalBrandId: action.payload
      }
    case SUCCESS_SET_GLOBAL_LINE:
      return {
        ...state,
        globalLineId: action.payload
      }
    case SUCCESS_SET_GLOBAL_LANGUAGE:
      return {
        ...state,
        globalLanguageId: action.payload
      }
    case SUCCESS_SET_GLOBAL_COUNTRY:
      return {
        ...state,
        globalCountryId: action.payload
      }
    case SUCCESS_SET_GLOBAL_COUNTRIES:
      return {
        ...state,
        globalCountriesId: action.payload
      }
    case SUCCESS_SET_GLOBAL_ROLE:
      return {
        ...state,
        globalRoleId: action.payload
      }
    case SUCCESS_SET_GLOBAL_ORDERBY:
      return {
        ...state,
        globalOrderById: action.payload
      }
    case SUCCESS_SET_GLOBAL_TAG:
      return {
        ...state,
        globalTag: action.payload
      }
    case SUCCESS_GLOBAL_SEARCH_QUERY:
      return {
        ...state,
        globalSearch: action.payload.globalsearch,
        loadingSearch: false
      }
    default:
      return state
  }
}
